export default "/images/bbb1d99bfe0d3f64c5870ef83798028b.avif";